import { PaginatedResponse } from "api/common/types/response.types";
import { Ear } from "api/memberPortal/ear/ear.types";
import DefaultDataGrid from "components/MUI/DataGrid/DefaultDataGrid";

import ProductsEarsColumns from "./EarProductTable.columns";

interface EarProductTableProps {
  ears?: PaginatedResponse<Ear>;
  isLoading: boolean;
  onAdd?: () => void | undefined;
}

const EarProductTable = ({ ears, isLoading, onAdd }: EarProductTableProps) => {
  return (
    <DefaultDataGrid
      columns={ProductsEarsColumns}
      rows={ears?.results}
      loading={isLoading}
      title={"EAR Reviews"}
      getRowId={(row) => row.earid}
      pageSizeOptions={[5, 10, 20]}
      onAdd={onAdd}
      initialState={{
        pagination: {
          paginationModel: { pageSize: 5 },
        },
      }}
    />
  );
};

export default EarProductTable;
